/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPoints } from '../../models/user-points';

export interface GetLoyaltyUserPoints$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  time?: string;
}

export function getLoyaltyUserPoints(http: HttpClient, rootUrl: string, params: GetLoyaltyUserPoints$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPoints>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyUserPoints.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.header('time', params.time, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPoints>;
    })
  );
}

getLoyaltyUserPoints.PATH = '/loyalty/users/{userId}/points';
